import * as React from 'react';
import cn from 'classnames';
import { Close16, IconButton } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IContainerLayoutProps } from '../../ContainerLayout';

export const MobileContainerLayout: React.FC<IContainerLayoutProps & { onClose: () => void }> = ({
  title,
  content,
  actions,
  isWithRingLabelImage,
  onClose,
  actionsGap,
}) => {
  return (
    <section className={cn(styles['container'], isWithRingLabelImage && styles['container-with-ring-label-image'])}>
      <h2 className={cn(styles['title'])}>
        {title}
        {isWithRingLabelImage && <span className={cn(styles['label'])}>Онлайн-сделка</span>}
      </h2>
      <div className={cn(styles['content'])}>{content}</div>
      <div className={cn(styles['actions'], styles[`actions-gap-${actionsGap}`])}>{actions}</div>
      <div className={styles['close-button']}>
        <IconButton aria-label='Скрыть блок "Онлайн.Сделка"' onClick={onClose} icon={<Close16 />} />
      </div>
    </section>
  );
};
